import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=fa032340&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=js&"
export * from "./Debug.vue?vue&type=script&lang=js&"
import style0 from "./Debug.vue?vue&type=style&index=0&id=fa032340&lang=scss&scoped=true&"
import style1 from "./Debug.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa032340",
  null
  
)

export default component.exports